import { DownOutlined, EditOutlined, UploadOutlined } from "@ant-design/icons";
import {
  Button,
  Dropdown,
  Form,
  Image,
  Input,
  Menu,
  message,
  Modal,
  notification,
  Spin,
  Upload,
  DatePicker,
  Select,
  Tag,
} from "antd";
import { compact } from "lodash";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import moment from "moment";
import { Prompt, withRouter } from "react-router-dom";
import CustomAppBar from "../../components/./CustomAppBar.js";
import CustomFilterHeader from "../../components/./CustomFilterHeader.js";
import AntTable from "../../components/AntTableV2";
import ExportButton from "../../components/Styles/ExportButton";
import ApiWrapper from "../../utils/ApiWrapper.js";
import MapProductToSKU from "../inventory/MasterSKUMapping/MapProductToSKU";
import CategoryConfigPopup from "./CategoryConfigPopup";
import { PostValues } from "../../utils/api-client.js";

const { Option } = Select;
const EditableContext = React.createContext(null);
// const EditableContext = React.createContext(null);
const EditableRow = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

const EditableCell = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef(null);
  const form = useContext(EditableContext);
  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing);
    form.setFieldsValue({
      [dataIndex]: record[dataIndex],
    });
  };

  const save = async () => {
    try {
      const values = await form.validateFields();
      toggleEdit();
      handleSave({ ...record, ...values });
    } catch (errInfo) {
      console.log("Save failed:", errInfo);
    }
  };

  let childNode = children;

  if (editable) {
    childNode = editing ? (
      <Form.Item
        style={{
          margin: 0,
        }}
        name={dataIndex}
        rules={[
          {
            required: true,
            message: `${title} is required.`,
          },
        ]}
      >
        <Input
          className="heightInitial text-left"
          ref={inputRef}
          onPressEnter={save}
          onBlur={save}
        />
      </Form.Item>
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{
          paddingRight: 24,
        }}
      >
        {children}
        <EditOutlined onClick={toggleEdit} />
      </div>
    );
  }

  return <td {...restProps}>{childNode}</td>;
};

let AllProductConfigs = [];
function ProductConfig(props) {
  const [form] = Form.useForm();

  let initialValues = {
    masterSKU: "",
    category: "",
    costPerUnit: "",
  };
  const handleManualSyncClick = (event) => {};
  const [productList, setProductList] = useState([]);
  const [filteredProductList, setFilteredProductList] = useState([]);
  const [selectedMarketplaces, setSelectedMarketplaces] = useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [searchText, setSearchText] = React.useState("");
  const [blockNavigate, setBlockNavigate] = useState(false);
  const [editKey, setEditKey] = useState("");
  const [openMapMasterSKU, setOpenMapMasterSKU] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [tbcOpen, setTbcOpen] = React.useState(false);
  const [tbcSku, setTbcSku] = React.useState("");
  const [tbcData, setTbcData] = React.useState({});
  const [startDate, setStartDate] = useState(moment().subtract(1, "month"));
  const [totalRecords, setTotalRecords] = React.useState(0);
  const [marketPlaces, setMarketPlaces] = React.useState([]);
  const [requestData, setRequestData] = React.useState({});
  const [isExportLoading, setIsExportLoading] = React.useState(false);
  const [fileList, setFileList] = React.useState([]);

  const getInventory = async (requestData) => {
    let response = await PostValues("getInventory_V3", requestData);
    return response;
  };
  const getExportApi = async (requestData) => {
    let response = await PostValues("getOrganisationReportApi", requestData);
    return response;
  };
  let arr = [];
  const prepareData = (orders) => {
    orders.forEach((row, index) => {
      arr.push({
        ...row,
        key: `${row.channel}_${index}`,
      });
    });
    return arr;
  };
  const handleMarketplaceChange = async (
    selectedMarketplaces,
    fromDate,
    toDate
  ) => {
    setIsLoading(true);
    setMarketPlaces(selectedMarketplaces);

    var noOfMarketplaces = selectedMarketplaces.length;

    let requestData = {
      channels: selectedMarketplaces.map((mp) => mp.name),

      filters: {
        status: { IN: ["ACTIVE", "INACTIVE", "Active", "Inactive"] }, // for both status
      },
      pagination: {
        pageNo: 0,
        pageSize: 25,
      },
    };
    const data = await getInventory(requestData);
    setRequestData(requestData);

    if (data.listings) {
      const inventoryData = await prepareData(data.listings);
      setProductList([...inventoryData]);
      setTotalRecords(data.pagination.count);
      setIsLoading(false);
    }
  };

  const onTableChange = async ({
    paginationCondition,
    sortCondition,
    filterCondition,
    extra,
  }) => {
    setIsLoading(true);

    let requestData = {
      channels: marketPlaces.map((mp) => mp.name),

      filters: {
        status: { IN: ["ACTIVE", "INACTIVE", "Active", "Inactive"] },
        ...filterCondition,
      },
      ...paginationCondition,
      ...sortCondition,
    };
    const data = await getInventory(requestData);
    setRequestData(requestData);

    if (data.listings) {
      const inventoryData = await prepareData(data.listings);
      setProductList([...inventoryData]);
      setTotalRecords(data.pagination.count);
      setIsLoading(false);
    }
  };
  const ExportAllData = async () => {
    try {
      setIsExportLoading(true);
      let exportRequestData = {
        params: {
          channels: marketPlaces.map((mp) => mp.name),
          status: { IN: ["ACTIVE", "INACTIVE", "Active", "Inactive"] },
        },
        reportType: "listings",
      };
      const data = await getExportApi(exportRequestData);
      if (data.status) {
        setIsExportLoading(false);
        message.success(
          "The export is being processed, please check the Downloads page ",
          10
        );
      } else {
        setIsExportLoading(false);
      }
    } catch (error) {
      setIsExportLoading(false);
    }
  };
  const onSearch = async (ds, searchText) => {
    let params = { ...requestData };
    if (params.filters) {
      params.filters.search = searchText.trim();
    } else {
      params.filters = {
        search: searchText.trim(),
      };
    }
    setIsLoading(true);
    const data = await getInventory(params);
    setIsLoading(false);
    if (data.listings) {
      const inventoryData = await prepareData(data.listings);
      setProductList([...inventoryData]);
      setTotalRecords(data.pagination.count);
    }
    return [];
  };

  const handleTBCOpen = (record) => {
    setTbcData({
      open: true,
      sku: record.sku,
    });
  };

  const handleTBCClose = () => {
    setTbcData({
      ...tbcData,
      open: false,
    });
  };

  React.useEffect(() => {
    if (blockNavigate) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = undefined;
    }
  }, [blockNavigate]);

  const handleMapProductOpen = (record) => {
    setSelectedData(record);
    setOpenMapMasterSKU(true);
  };

  const handleMapProductClose = () => {
    setSelectedData(null);
    setOpenMapMasterSKU(false);
  };

  const unMapProductToSKU = async (record) => {
    let requestJsonBody = {
      listings: [
        {
          masterSKU: record.masterSKU,
          channel: record.channel,
          sku: record.sku,
          isMap: false,
        },
      ],
    };
    ApiWrapper("updateMasterSKU", requestJsonBody).then(
      function (response) {
        if (response.status) {
          handleMarketplaceChange(selectedMarketplaces, "", "");
        }
      },
      function (error) {
        // message.error(
        //   "We encountered an issue. Please log out and log back in. "
        // );
      }
    );
  };

  const updateCategory = (mainCategory, subCategory, sku) => {
    let updateRequestBody = [
      {
        category: mainCategory + "%23" + subCategory,
        sku: sku,
      },
    ];
    ApiWrapper("updateAmazonCategory", updateRequestBody).then(
      function (updateResponse) {
        setTbcData({
          ...tbcData,
          open: false,
        });
        message.success("Category updated successfully!");
      },
      function (error) {
        // message.error(
        //   "We encountered an issue. Please log out and log back in. "
        // );
      }
    );
  };

  const openCategoryChange = {};
  const taxValues = ["0",'3', "5", "12", "18", "28"];
  const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
  }) => {
    const inputNode =
      inputType === "dropDown" ? (
        <Select style={{ width: 120 }}>
          {taxValues.map((val) => {
            return <Option value={val}>{`${val}%`}</Option>;
          })}
        </Select>
      ) : (
        <Input disabled={disabled} className=" h-6 w-full p-4" />
      );
    let disabled;
    if (record) {
      disabled = Boolean(record[restProps.form_name] === "");
    } else {
      disabled = false;
    }
    return (
      <td {...restProps}>
        {editing ? (
          <div>
            <Form.Item
              name={restProps.form_name}
              style={{ margin: 0 }}
              rules={[
                {
                  required: true,
                  message: `Please Input ${title}!`,
                },
              ]}
            >
              {inputNode}
            </Form.Item>
          </div>
        ) : (
          children
        )}
      </td>
    );
  };

  const components = {
    body: {
      cell: EditableCell,
    },
  };

  // const components = {
  //   body: {
  //     row: EditableRow,
  //     cell: EditableCell,
  //   },
  // };

  const onEditRow = (record) => {
    setBlockNavigate(true);
    form.setFieldsValue({
      masterSKU: record.masterSKU || "-",
      category: record.category || "-",
      costPerUnit: record.costPerUnit,
      costPerUnitTax: record.costPerUnitTax,
    });
    setEditKey(record.key);
  };

  const onCancelRow = (record) => {
    form.setFieldsValue({
      masterSKU: "",
      category: "",
      costPerUnit: "",
      costPerUnitTax: "",
    });
    setEditKey("");
  };

  const onSaveRow = async (record) => {
    try {
      const row = await form.validateFields();

      let requestJsonBody = {
        listings: [
          {
            sku: record.sku,
            quantity: record.quantity,
            masterSKU: row.masterSKU,
            channel: record.channel,
            costPerUnit: row.costPerUnit,
            costPerUnitTax: row.costPerUnitTax,
            costPerUnitFromDate: startDate ? startDate.utc().format() : "",
            // costPerUnitToDate: startDate[1],
          },
        ],
      };
      let reqData = {
        updated_at: new Date(),
        module_name: "ProductCofiguration",
        updated_value:  {
          sku: record.sku,
          quantity: record.quantity,
          masterSKU: row.masterSKU,
          channel: record.channel,
          COGS: record.costPerUnit,
          COGSTax: record.costPerUnitTax,
          UpdatedCOGS: row.costPerUnit,
          UpdatedCOGSTax: row.costPerUnitTax,
          costPerUnitFromDate: startDate ? startDate.utc().format() : "",
        }, 
      };
      // console.log(requestJsonBody);
      ApiWrapper("updateCostPerUnit", requestJsonBody).then(
        function (response) {
          let productListTmp = productList.map((product) => {
            if (product.key === record.key) {
              product.category = row.category;
              product.masterSKU = row.masterSKU;
              product.costPerUnit = row.costPerUnit;
              product.costPerUnitTax = row.costPerUnitTax;
            }
            return product;
          });
          setProductList(productListTmp);
          let filterProductListTmp = filteredProductList.map((product) => {
            if (product.key === record.key) {
              product.category = row.category;
              product.masterSKU = row.masterSKU;
              product.costPerUnit = row.costPerUnit;
              product.costPerUnitTax = row.costPerUnitTax;
            }
            return product;
          });
          setFilteredProductList(filterProductListTmp);
          setProductList(productListTmp);
          onCancelRow(record);
          //props.reloadApi(data);
          if (response.status) {
            ApiWrapper("updateChangeLog", reqData).then(
              function (response) {
              },
              function (error) {}
            );
          }
        },
        function (error) {
          // message.error(
          //   "We encountered an issue. Please log out and log back in. "
          // );
        }
      );
    } catch (error) {}
    setEditKey("");
  };

  const RefColumns = [
    {
      title: "Sno",
      align: "center",
      field: "channel",
      width: 80,
      render: (record, rowIndex) => rowIndex,
    },
    {
      title: "Channel",
      align: "center",
      field: "channel",
      width: 80,

      render: (record, rowIndex) =>
        record.channel === "Amazon-India" ? (
          <div className="amazon-logo-small" />
        ) : record.channel === "Flipkart" ? (
          <div className="flipkart-logo-small" />
        ) : (
          "-"
        ),
      isFilterable: true,
      type: "string",
    },
    {
      title: "Image",
      align: "center",
      field: "productId",
      width: 100,

      render: (record, rowIndex) => (
        <Image
          // width={70}
          // height={70}
          style={{
            height: 36,
            width: 36,
            objectFit: "cover",
            border: "1px solid #EAE6FF",
          }}
          src={record.imageURL || "-"}
          fallback="data:image/png;base64,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"
        />
      ),
    },
    {
      title: "Marketplace SKU",
      field: "sku",
      width: 0,
      hidden: false,
      width: 150,
    },
    {
      title: "Product Id",
      field: "productId",
      width: 0,
      hidden: false,
      width: 120,
    },
    {
      title: "Listing Status",
      field: "status",
      width: 100,
      render: (record, rowIndex, isLoading) => (
        <Tag
          color={
            (record?.status || "").toLowerCase() === "active" ? "green" : "red"
          }
        >
          {record?.status}
        </Tag>
      ),
      onFilter: (value, record) => {
        if (value === "-") {
          if (!record.status) {
            return true;
          }
        } else {
          return (record.status || "").toLowerCase() === value;
        }
      },
      filters: [
        { text: "Active", value: ["ACTIVE", "Active"] },
        { text: "Inactive", value: ["INACTIVE", "Inactive"] },
      ],
    },
    {
      title: "Name",
      align: "center",
      isFilter: true,
      field: "name",
      ellipsis: true,
      isFilterable: true,
      isSearchable: true,
      type: "string",
      width: 250,
      render: (record, rowIndex) => record.name || "", //.replace(/(.{20})..+/, "$1…"),
      sorter: (a, b) => {
        a = (a.name || "").toLowerCase();
        b = (b.name || "").toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
      sortDirections: ["descend", "ascend", "descend"],
    },
    {
      title: "Master SKU",
      align: "center",
      isFilterable: true,
      type: "string",
      field: "masterSKU",
      isSearchable: true,
      editable: true,
      render: (record, rowIndex) =>
        record.masterSKU !== null ? (
          <div className="flex flex-col items-center justify-center">
            <div className="mr-2">{record.masterSKU}</div>
            <ExportButton
              variant="outlined"
              onClick={() => unMapProductToSKU(record)}
            >
              <div className="text-sm">UnMap</div>
            </ExportButton>
          </div>
        ) : (
          <ExportButton
            variant="outlined"
            onClick={() => handleMapProductOpen(record)}
          >
            <div className="text-sm">Map</div>
          </ExportButton>
        ),
      sorter: (a, b) => {
        a = (a.masterSKU || "").toLowerCase();
        b = (b.masterSKU || "").toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
      sortDirections: ["descend", "ascend", "descend"],
    },
    // {
    //   title: "Product Category",
    //   align: "center",
    //   field: "category",
    //   type: "string",
    //   isFilterable: true,
    //   editable: true,
    //   render: (record, rowIndex, isLoading) =>
    //     record.category !== undefined ? (
    //       <div className="flex flex-col items-center justify-center">
    //         <div className="mr-2">{record.category}</div>
    //         {/* <ExportButton
    //           variant="outlined"
    //           onClick={() => handleTBCOpen(record)}
    //         >
    //           <div className="text-sm">Edit</div>
    //         </ExportButton> */}
    //       </div>
    //     ) : null,
    //   searchPriority: 5,
    //   onSearch: (searchText) => (data) =>
    //     (data || "").toLowerCase().includes(searchText.toLowerCase()),
    //   sorter: (a, b) => {
    //     a = (a.category || "").toLowerCase();
    //     b = (b.category || "").toLowerCase();
    //     return a > b ? -1 : b > a ? 1 : 0;
    //   },
    //   sortDirections: ["descend", "ascend", "descend"],
    // },
    // {
    //   title: "Product Dimensions",
    //   align: "center",
    //   field: "productDimensions",
    //   sorter: (a, b) => {
    //     a = (a || {}).price || 0;
    //     b = (b || {}).price || 0;
    //     return a - b;
    //   },
    //   sortDirections: ["descend", "ascend", "descend"],
    //   // render: (record, rowIndex) => "-"
    // },
    // {
    //   title: "Package Dimensions",
    //   align: "center",
    //   field: "packageDimensions",
    //   sorter: (a, b) => {
    //     a = (a || {}).price || 0;
    //     b = (b || {}).price || 0;
    //     return a - b;
    //   },
    //   sortDirections: ["descend", "ascend", "descend"],
    //   // render: (record, rowIndex) => "-"
    // },
    {
      title: "Cost Per Unit",
      align: "center",
      isFilterable: true,
      isTotal: true,
      field: "costPerUnit",
      type: "number",
      editable: true,
      sorter: (a, b) => {
        a = (a || {}).costPerUnit || 0;
        b = (b || {}).costPerUnit || 0;
        return a - b;
      },
      sortDirections: ["descend", "ascend", "descend"],

      //render: (record, rowIndex) => record.costPerUnit || 0
    },
    {
      title: "Unit Tax",
      align: "center",
      isFilterable: true,
      isTotal: true,
      field: "costPerUnitTax",
      type: "number",
      form_name: "costPerUnitTax",
      editable: true,
      sorter: (a, b) => {
        a = (a || {}).costPerUnitTax || 0;
        b = (b || {}).costPerUnitTax || 0;
        return a - b;
      },
      sortDirections: ["descend", "ascend", "descend"],
    },
    {
      title: "",
      align: "center",
      field: "",
      width: 150,
      render: (record, rowIndex, isLoading) =>
        editKey === record.key ? (
          <React.Fragment>
            <Button
              onClick={() => onSaveRow(record)}
              style={{ marginRight: 16 }}
              type="primary"
              size="small"
            >
              Save
            </Button>
            <Button
              variant="outlined"
              onClick={() => onCancelRow(record)}
              size="small"
            >
              Cancel
            </Button>
          </React.Fragment>
        ) : (
          <Button
            variant="outlined"
            size="small"
            onClick={() => onEditRow(record)}
          >
            Edit
          </Button>
        ),
    },
  ];

  const [columns, setColumns] = React.useState(RefColumns);
  const [uploadVisible, setUploadVisible] = React.useState(false);
  const [confirmLoading, setConfirmLoading] = React.useState(false);
  const [modifiedData, setModifiedData] = React.useState([]);

  const onSearchTextEntered = (searchText) => {
    setSearchText(searchText);
  };

  const mergedColumns = compact(RefColumns).map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.field === "costPerUnitTax" ? "dropDown" : "number",
        dataIndex: col.field,
        title: col.title,
        editing: editKey === record.key,
        form_name: col.field || "",
      }),
    };
  });

  const uploadProps = {
    name: "file",
    headers: {
      authorization: "authorization-text",
    },
    multiple: false,
    accept: ".csv",
    maxCount: 1,
    customRequest({ file, onSuccess }) {
      onSuccess([], file);
    },
    onChange(info) {
      //setUploadedData(info);
      // if (info.file.status === "done") {
      // } else if (info.file.status === "error") {
      //   message.error(`${info.file.name} file upload failed.`);
      // }
    },
  };
  const onFileChange = (files) => {
    setFileList(files.fileList.map((file) => ({ ...file, status: "done" })));
    window.Papa.parse(files.file.originFileObj, {
      worker: true,
      complete: function (results) {
        let csvData = results.data.map((data, i) => {
          if (i > 0 && data[0] != "") {
            if (data[0] === "Both") {
              return {
                channel: data[0],
                sku: data[0] === "Amazon-India" ? data[6] : data[7],
                masterSKU: data[5],
                "Amazon-India-sku": data[6],
                "Flipkart-sku": data[7],
                "Amazon-India-price": data[8],
                "Flipkart-price": data[9],
                quantity: data[10],
              };
            } else {
              return {
                channel: data[0],
                masterSKU: data[5],
                sku: data[0] === "Amazon-India" ? data[6] : data[7],
                price: data[0] === "Amazon-India" ? data[8] : data[9],
                quantity: data[10],
                costPerUnit: data[12],
                costPerUnitTax: data[13],
                costPerUnitFromDate: startDate ? startDate.utc().format() : "",
              };
            }
          } else {
            return null;
          }
        });
        setModifiedData(compact(csvData));
      },
    });
  };
  const onBeforeUpload = (file, fileList) => {
    let uploadedRows = [];
    if (typeof FileReader != "undefined") {
      const reader = new FileReader();
      reader.onload = async (e) => {
        let rows = e.target.result;
        let columnMap = {
          "Cost Per Unit": "costPerUnit",
          "Master SKU": "masterSKU",
        };

        window.Papa.parse(rows, {
          header: true,
          complete: (results) => {
            console.log(results);
            let modifiedRowsCPU = [];
            let modifiedRowsMasterSKU = [];
            uploadedRows = results.data.reduce((prodMap, product) => {
              prodMap[`${product["Product ID"]}}`] = product;
              return prodMap;
            }, {});
            productList.map((product) => {
              let rowKey = `${product.productId}`;
              if (uploadedRows[rowKey]) {
                Object.keys(columnMap).map((exportCol) => {
                  let originalValue = product[columnMap[exportCol]];
                  let modifiedValue = uploadedRows[rowKey][exportCol];
                  if (
                    (!modifiedValue && originalValue) ||
                    (!originalValue && modifiedValue) ||
                    (modifiedValue &&
                      originalValue &&
                      String(modifiedValue) !== String(originalValue))
                  ) {
                    // modifiedCols[columnMap[exportCol]] = modifiedValue;
                    if (exportCol === "Cost Per Unit") {
                      modifiedRowsCPU.push({
                        sku: product.sku,
                        quantity: product.quantity,
                        masterSKU: product.masterSKU,
                        channel: product.channel,
                        costPerUnit: product.costPerUnit,
                        [columnMap[exportCol]]: modifiedValue,
                      });
                    } else if (exportCol === "Master SKU") {
                      modifiedRowsMasterSKU.push({
                        masterSKU: product.masterSKU,
                        channel: product.channel,
                        sku: product.sku,
                        isMap: true,
                        [columnMap[exportCol]]: modifiedValue,
                      });
                    }
                  }
                });
              }
            });
            if (modifiedRowsCPU.length || modifiedRowsMasterSKU.length) {
              setModifiedData({
                cpu: modifiedRowsCPU,
                sku: modifiedRowsMasterSKU,
              });
              return true;
            } else {
              message.error("No changes found");
            }
          },
        });
      };

      if (file.name.includes(".csv") || file.type.includes("csv")) {
        reader.readAsText(file);
      }
    } else {
      alert("This browser does not support HTML5.");
    }
    return true;
    // Prevent upload
    // return false;
  };
  const onFileUpload = async () => {
    let requestJsonBody = {
      listings: modifiedData,
    };
    let response = await ApiWrapper("updateInventory_v2", requestJsonBody);
    if (response.status) {
      message.success("File Uploaded successfully");
    }
    setFileList([]);
    setModifiedData([]);
  };

  const downloadCategoryList = () => {
    ApiWrapper("getAmazonCategories", {}).then(
      function (response) {
        if (response.status) {
          let data = response.data;
          data = data.reduce((mainCategories, category) => {
            return { ...mainCategories, ...category };
          }, {});
          let csvData = [];
          Object.keys(data).map((catName) => {
            data[catName].map((subCatObj) => {
              csvData.push({
                Category: catName,
                SubCategory: subCatObj.key,
                "Category Value": catName + "#" + subCatObj.key,
              });
            });
          });
          const csv = window.Papa.unparse(csvData, {
            greedy: true,
            header: true,
          });
          const blob = new Blob([csv]);
          const a = window.document.createElement("a");
          a.href = window.URL.createObjectURL(blob);
          a.download = `CategoryList.csv`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      },
      function (error) {
        message.warning("Category List download failed");
      }
    );
  };

  const downloadMasterSKUs = () => {
    ApiWrapper("getMasterSKUs", {}).then(
      function (response) {
        if (response.listings.Items.length > 0) {
          let data = response.listings.Items;
          let masterSKUs = data.map((item) => item.masterSKU);
          const csv = window.Papa.unparse(
            { fields: ["Master SKU"], data: masterSKUs },
            {
              greedy: true,
              header: true,
            }
          );
          const blob = new Blob([csv]);
          const a = window.document.createElement("a");
          a.href = window.URL.createObjectURL(blob);
          a.download = `MasterSKUlist.csv`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      },
      function (error) {
        message.warning("Master SKU list download failed.");
      }
    );
  };

  // const DownloadMenu = (
  //   <Menu>
  //     <Menu.Item key="1" onClick={downloadCategoryList}>
  //       Category List
  //     </Menu.Item>
  //     <Menu.Item key="2" onClick={downloadMasterSKUs}>
  //       MasterSKU list
  //     </Menu.Item>
  //   </Menu>
  // );
  const UploadButton = (
    <div className="flex items-center justify-end">
      <p className="mr-1">Change Product Cost From: </p>
      <DatePicker
        onChange={(date, dateStrings) => {
          setStartDate(date);
        }}
        placeholder="ProductCost Fromdate"
        className="mr-2 w-50"
        format={"DD/MM/YYYY"}
        defaultValue={ moment().subtract(1, "month")}
        disabledDate={(date) => {
          return date < moment().subtract(1, "month");
        }}
      />{" "}
      <Button
        className="mr-2 font-Inter rounded" //text-secondary bg-GhostWhite hover:border-gray
        type="primary"
        size="middle"
        onClick={() => {
          setUploadVisible(true);
        }}
      >
        Upload
      </Button>
      {/* <Dropdown overlay={DownloadMenu} className="mr-2">
        <Button>
          Download <DownOutlined />
        </Button>
      </Dropdown> */}
      <Modal
        className="z-10"
        title="File Upload"
        visible={uploadVisible}
        onOk={onFileUpload}
        confirmLoading={confirmLoading}
        onCancel={() => {
          setUploadVisible(false);
        }}
        okText="Submit"
      >
        <Upload
          {...uploadProps}
          accept=".csv"
          onChange={onFileChange}
          fileList={fileList}
          error={() => {
            console.log("Upload Failed");
          }}
          maxFileSize={28400000}
        >
          <Button icon={<UploadOutlined />}>Click to Upload</Button>
        </Upload>
      </Modal>
    </div>
  );

  return (
    <>
      <Prompt
        when={blockNavigate}
        message="You have unsaved changes, are you sure you want to leave?"
      />
      {confirmLoading && (
        <div
          className="fixed inset-0 bg-white bg-opacity-40 flex items-center justify-center "
          style={{
            zIndex: 9999,
          }}
        >
          <Spin spinning={confirmLoading}></Spin>
        </div>
      )}

      <Helmet>
        <title>{"Product Configuration | Forcesight"}</title>
      </Helmet>
      <CustomAppBar />
      <CustomFilterHeader
        headerTitle="Product Configuration"
        handleManualSyncClick={handleManualSyncClick}
        handleMarketplaceChange={handleMarketplaceChange}
        onSearchTextEntered={onSearchTextEntered}
        columns={columns}
        rows={productList}
        showManualSync={false}
        showDateRanges={false}
        showExportButton={false}
        isLoading={isDataLoading}
        searchHide={true}
        searchFunction={onSearch}
        exportFileName="productConfiguration"
        onFilterUpdate={(data) => {
          setFilteredProductList(data);
        }}
        publishButton={UploadButton}
        customToggleProfit={
          <Spin spinning={isExportLoading}>
            <div className="ml-6">
              <ExportButton variant="outlined" onClick={ExportAllData}>
                Export to CSV
              </ExportButton>
            </div>
          </Spin>
        }
      />
      <div style={{ marginLeft: 20, marginRight: 20 }}>
        <Form form={form} component={false} initialValues={initialValues}>
          <AntTable
            columns={mergedColumns}
            dataSource={productList}
            components={components}
            stickyHeader={{
              offsetHeader: 65,
              // offsetScroll: 216,
            }}
            // scroll={{ x: 1500 }}
            rowKey={(row, rowIndex) => rowIndex}
            isLoading={isLoading}
            hideSummary={true}
            totalRecords={totalRecords}
            searchText={[searchText]}
            onDataChange={onTableChange}
          />
        </Form>
      </div>
      {openMapMasterSKU && (
        <MapProductToSKU
          open={openMapMasterSKU}
          handleClose={handleMapProductClose}
          data={selectedData}
          refreshList={() =>
            handleMarketplaceChange(selectedMarketplaces, "", "")
          }
        />
      )}
      {tbcData.open && (
        <CategoryConfigPopup
          open={tbcData.open}
          handleClose={handleTBCClose}
          onCategoryUpdate={updateCategory}
          sku={tbcData.sku}
        />
      )}
    </>
  );
}

export default withRouter(ProductConfig);
